import React from 'react';

export function ProfileCard({
  profileImageUrl,
  displayName,
  publicName,
  bio,
  websiteUrl,
  onClick,
}) {
  const getInitials = (name) => {
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow ${
        onClick ? 'cursor-pointer' : ''
      }`}
    >
      <div className="flex items-start gap-4">
        {profileImageUrl ? (
          <img
            src={profileImageUrl}
            alt={displayName}
            className="w-16 h-16 rounded-full object-cover"
          />
        ) : (
          <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
            {getInitials(displayName)}
          </div>
        )}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900">{displayName}</h3>
          {publicName && (
            <p className="text-sm text-gray-500 mt-1">@{publicName}</p>
          )}
          {bio && (
            <p className="text-sm text-gray-600 mt-2 line-clamp-2">{bio}</p>
          )}
          {websiteUrl && (
            <a
              href={websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-500 hover:text-blue-600 mt-2 inline-block"
              onClick={(e) => e.stopPropagation()}
            >
              {websiteUrl.replace(/^https?:\/\//, '')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

